export default __webpack_public_path__ + "static/media/email.169d53f8.svg";